<template>
  <div class="box">
    <van-overlay :show="show">
      <van-loading class="loading" type="spinner" />
    </van-overlay>
  </div>
</template>
<script>
export default {

  props: {
    show: {
      type: Boolean
    }
  },
}
</script>
<style lang="scss" scoped>
.box {
  --van-overlay-z-index: 9999999;
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>